import { useTranslation } from "react-i18next";
import { SelectStyled } from "../../style/Input";
import { SubjectPropertyValue } from "../../types/subject-data.types";
import { SelectPair } from "../../types/common.types";

interface ISelectPaymentTypeProps {
  value: string | undefined;
  required?: boolean | undefined;
  onChange: (val: SubjectPropertyValue) => void;
}

const SelectPaymentType = (props: ISelectPaymentTypeProps) => {
  const { t } = useTranslation();

  const options = [
    {
      value: "",
      label: t("subject-payment-method-empty"),
    },
    {
      value: "B",
      label: t("subject-payment-method-B"),
    },
  ] as SelectPair[];

  return (
    <SelectStyled
      label={t("subject-payment-type-label")}
      tooltip={t("subject-payment-type-tooltip")}
      required={props.required}
      onChange={(type) => props.onChange(type)}
      value={props.value}
      options={options}
    />
  );
};

export default SelectPaymentType;
